var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 84,
    viewBox: "0 0 111 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.901 7.45947H13.7402V72.7179H110.901V7.45947Z",
    fill: "#E1E0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.901 0H15.7402C14.6357 0 13.7402 0.895429 13.7402 2V7.46017H110.901V2C110.901 0.895431 110.006 0 108.901 0Z",
    fill: "#ABA9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.785 12.168H15.1025V69.097H109.785V12.168Z",
    fill: "#ECECFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.6818 13.1816H16.2803V23.8287H27.6818V13.1816Z",
    fill: "#ABA9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2072 13.1816H27.8057V23.8287H39.2072V13.1816Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.7346 13.1816H39.333V23.8287H50.7346V13.1816Z",
    fill: "#ECECFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.26 13.1816H50.8584V23.8287H62.26V13.1816Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7873 13.1816H62.3857V23.8287H73.7873V13.1816Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M85.3088 13.1816H73.9072V23.8287H85.3088V13.1816Z",
    fill: "#ABA9FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8361 13.1816H85.4346V23.8287H96.8361V13.1816Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.36 13.1816H96.958V23.8287H108.36V13.1816Z",
    fill: "#ECECFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.6818 24.0469H16.2803V34.6939H27.6818V24.0469Z",
    fill: "#ECECFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.2072 24.0469H27.8057V34.6939H39.2072V24.0469Z",
    fill: "#ECECFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7346 24.0469H39.333V34.6939H50.7346V24.0469Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M62.26 24.0469H50.8584V34.6939H62.26V24.0469Z",
    fill: "#ECECFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7873 24.0469H62.3857V34.6939H73.7873V24.0469Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.3088 24.0469H73.9072V34.6939H85.3088V24.0469Z",
    fill: "#ECECFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M96.8361 24.0469H85.4346V34.6939H96.8361V24.0469Z",
    fill: "#ABA9FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M108.36 24.0469H96.958V34.6939H108.36V24.0469Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6818 34.7656H16.2803V45.4127H27.6818V34.7656Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2072 34.7656H27.8057V45.4127H39.2072V34.7656Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.7346 34.7656H39.333V45.4127H50.7346V34.7656Z",
    fill: "#ECECFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.26 34.7656H50.8584V45.4127H62.26V34.7656Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.7873 34.7656H62.3857V45.4127H73.7873V34.7656Z",
    fill: "#ECECFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3088 34.7656H73.9072V45.4127H85.3088V34.7656Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8361 34.7656H85.4346V45.4127H96.8361V34.7656Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.36 34.7656H96.958V45.4127H108.36V34.7656Z",
    fill: "#ECECFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6818 45.4854H16.2803V56.1324H27.6818V45.4854Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.2072 45.4854H27.8057V56.1324H39.2072V45.4854Z",
    fill: "#6020D4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.7346 45.4854H39.333V56.1324H50.7346V45.4854Z",
    fill: "#ABA9FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M62.26 45.4854H50.8584V56.1324H62.26V45.4854Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7873 45.4854H62.3857V56.1324H73.7873V45.4854Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M85.3088 45.4854H73.9072V56.1324H85.3088V45.4854Z",
    fill: "#ABA9FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8361 45.4854H85.4346V56.1324H96.8361V45.4854Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M108.36 45.4854H96.958V56.1324H108.36V45.4854Z",
    fill: "#ABA9FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.6818 56.3486H16.2803V66.9957H27.6818V56.3486Z",
    fill: "#6020D4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.2072 56.3486H27.8057V66.9957H39.2072V56.3486Z",
    fill: "#6020D4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7346 56.3486H39.333V66.9957H50.7346V56.3486Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M62.26 56.3486H50.8584V66.9957H62.26V56.3486Z",
    fill: "#ABA9FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.7873 56.3486H62.3857V66.9957H73.7873V56.3486Z",
    fill: "#ECECFF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3088 56.3486H73.9072V66.9957H85.3088V56.3486Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.8361 56.3486H85.4346V66.9957H96.8361V56.3486Z",
    fill: "#ECECFF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M108.36 56.3486H96.958V66.9957H108.36V56.3486Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1321 14.3398H51.6621V18.3959H55.1321V14.3398Z",
    fill: "#ABA9FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M54.765 35.7803H51.2949V39.8363H54.765V35.7803Z",
    fill: "#ABA9FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5345 46.0654H63.0645V50.1214H66.5345V46.0654Z",
    fill: "#ABA9FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4622 35.7803H85.9922V39.8363H89.4622V35.7803Z",
    fill: "#ABA9FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2012 83.4579C37.03 83.4579 47.4298 72.6323 47.4298 59.2783C47.4298 45.9242 37.03 35.0986 24.2012 35.0986C11.3724 35.0986 0.972656 45.9242 0.972656 59.2783C0.972656 72.6323 11.3724 83.4579 24.2012 83.4579Z",
    fill: "#ABA9FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.199 78.925C34.6222 78.925 43.0719 70.1294 43.0719 59.2794C43.0719 48.4294 34.6222 39.6338 24.199 39.6338C13.7758 39.6338 5.32617 48.4294 5.32617 59.2794C5.32617 70.1294 13.7758 78.925 24.199 78.925Z",
    fill: "#FBFBFF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2681 44.0648L24.1387 59.1768L24.5848 59.3728L30.7143 44.2609L30.2681 44.0648Z",
    fill: "#ABA9FF",
    stroke: "#ABA9FF",
    strokeWidth: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5739 59.3316L24.1484 59.5723L28.1809 67.2968L28.6064 67.0562L24.5739 59.3316Z",
    fill: "#ABA9FF",
    stroke: "#ABA9FF",
    strokeWidth: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7831 60.2865C42.0506 60.2865 42.2674 60.0608 42.2674 59.7824C42.2674 59.504 42.0506 59.2783 41.7831 59.2783C41.5156 59.2783 41.2988 59.504 41.2988 59.7824C41.2988 60.0608 41.5156 60.2865 41.7831 60.2865Z",
    fill: "#6020D4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M24.203 41.6488C24.4705 41.6488 24.6873 41.4231 24.6873 41.1447C24.6873 40.8663 24.4705 40.6406 24.203 40.6406C23.9356 40.6406 23.7188 40.8663 23.7188 41.1447C23.7188 41.4231 23.9356 41.6488 24.203 41.6488Z",
    fill: "#ABA9FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3309 43.8244C33.4647 43.5833 33.3853 43.275 33.1537 43.1358C32.922 42.9965 32.6259 43.0792 32.4921 43.3203C32.3584 43.5614 32.4378 43.8697 32.6694 44.0089C32.901 44.1481 33.1972 44.0655 33.3309 43.8244Z",
    fill: "#ABA9FF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5287 50.6494C39.7603 50.5102 39.8397 50.2019 39.7059 49.9608C39.5722 49.7197 39.276 49.6371 39.0444 49.7763C38.8128 49.9155 38.7334 50.2238 38.8671 50.4649C39.0009 50.706 39.297 50.7886 39.5287 50.6494Z",
    fill: "#ABA9FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6053 69.1173C39.7391 68.8762 39.6597 68.5679 39.4281 68.4287C39.1965 68.2895 38.9003 68.3721 38.7666 68.6132C38.6328 68.8543 38.7122 69.1627 38.9438 69.3019C39.1754 69.4411 39.4716 69.3585 39.6053 69.1173Z",
    fill: "#ABA9FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8138 75.8164C33.0455 75.6772 33.1248 75.3689 32.9911 75.1278C32.8574 74.8867 32.5612 74.8041 32.3296 74.9433C32.0979 75.0825 32.0186 75.3908 32.1523 75.6319C32.286 75.873 32.5822 75.9556 32.8138 75.8164Z",
    fill: "#ABA9FF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7318 44.0117C15.9634 43.8725 16.0428 43.5642 15.9091 43.3231C15.7753 43.082 15.4791 42.9994 15.2475 43.1386C15.0159 43.2778 14.9365 43.5861 15.0703 43.8272C15.204 44.0683 15.5002 44.1509 15.7318 44.0117Z",
    fill: "#ABA9FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53503 50.463C9.66876 50.2219 9.5894 49.9136 9.35777 49.7744C9.12615 49.6352 8.82997 49.7178 8.69624 49.9589C8.56251 50.2001 8.64187 50.5084 8.8735 50.6476C9.10512 50.7868 9.4013 50.7042 9.53503 50.463Z",
    fill: "#ABA9FF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0829 60.3672C42.3838 60.1864 42.4868 59.786 42.3131 59.4728C42.1395 59.1597 41.7548 59.0524 41.4539 59.2332C41.1531 59.414 41.05 59.8144 41.2237 60.1276C41.3974 60.4408 41.7821 60.548 42.0829 60.3672Z",
    fill: "#ABA9FF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45934 69.3017C9.69097 69.1625 9.77032 68.8542 9.63659 68.6131C9.50286 68.372 9.20669 68.2894 8.97506 68.4286C8.74344 68.5678 8.66407 68.8761 8.7978 69.1172C8.93153 69.3583 9.22771 69.441 9.45934 69.3017Z",
    fill: "#ABA9FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2479 75.633C16.3816 75.3919 16.3023 75.0836 16.0707 74.9443C15.839 74.8051 15.5429 74.8878 15.4091 75.1289C15.2754 75.37 15.3548 75.6783 15.5864 75.8175C15.818 75.9567 16.1142 75.8741 16.2479 75.633Z",
    fill: "#ABA9FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62002 60.2865C6.88748 60.2865 7.1043 60.0608 7.1043 59.7824C7.1043 59.504 6.88748 59.2783 6.62002 59.2783C6.35256 59.2783 6.13574 59.504 6.13574 59.7824C6.13574 60.0608 6.35256 60.2865 6.62002 60.2865Z",
    fill: "#ABA9FF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24.203 77.9164C24.4705 77.9164 24.6873 77.6907 24.6873 77.4123C24.6873 77.1339 24.4705 76.9082 24.203 76.9082C23.9356 76.9082 23.7188 77.1339 23.7188 77.4123C23.7188 77.6907 23.9356 77.9164 24.203 77.9164Z",
    fill: "#ABA9FF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.91482 60.6542C5.91606 56.3251 7.29075 52.1176 9.82531 48.6854C12.3599 45.2532 15.9124 42.7884 19.931 41.6739C23.9497 40.5594 28.2094 40.8576 32.0485 42.5222C35.8875 44.1868 39.091 47.1246 41.1612 50.8792C40.1454 48.4228 38.6585 46.2082 36.7916 44.3709C34.9248 42.5336 32.7172 41.1124 30.3043 40.1943C27.8913 39.2761 25.3236 38.8804 22.7586 39.0313C20.1936 39.1823 17.6851 39.8767 15.3869 41.072C13.0887 42.2674 11.0491 43.9385 9.39305 45.9831C7.737 48.0277 6.49933 50.4027 5.75587 52.9626C5.01241 55.5225 4.77879 58.2134 5.06934 60.8706C5.35988 63.5277 6.16847 66.0952 7.44558 68.4157C6.4325 65.9642 5.91158 63.3229 5.91482 60.6542Z",
    fill: "#ABA9FF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0894 61C24.8853 61 25.5304 60.3284 25.5304 59.5C25.5304 58.6716 24.8853 58 24.0894 58C23.2936 58 22.6484 58.6716 22.6484 59.5C22.6484 60.3284 23.2936 61 24.0894 61Z",
    fill: "#ABA9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCalendar);
export default __webpack_public_path__ + "static/media/EmptyCalendar.1906dad7d9060b36a03abfe5f998609f.svg";
export { ForwardRef as ReactComponent };